import { create } from 'zustand';

export const useSocketStore = create((set) => ({

    socket: null,

    connectionQuality: 'offline',
    connectionLatency: null,

    connectionReady: false,

    setSocket: socket =>
        set({ socket }),

    setConnectionQuality: connectionQuality =>
        set({ connectionQuality }),

    setConnectionLatency: connectionLatency =>
        set({ connectionLatency }),

    setConnectionReady: connectionReady =>
        set({ connectionReady })

}));